module.exports = __webpack_public_path__ + "img/case-logo-9.f511032b.png";